import styles from './styles.module.css';
import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';


import Img from "src/assets/images/home/about/about.webp"
import { isRTL } from 'src/utils/global';
import CustomButton from 'src/components/customButton/CustomButton';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa6';

const About = () => {
    const { t, i18n } = useTranslation("home");



    return (
        <Element data-aos="fade-up" name="aboutUs" className={`${styles.about} ${isRTL() && styles.rtl}`}>
            <div className='container'>
                <div className={'row'}>
                    <div className='col-lg-5 d-flex align-items-center'>
                        <div className={styles.img__con}>
                            <img
                                src={Img}
                                alt={t("about.title")}
                                width={460}
                                height={240}
                                loading='lazy'
                            />
                        </div>
                    </div>
                    <div className='col-lg-7 my-auto'>
                        <div className={styles.subTitle}>
                            {t("about.sub_title")}
                        </div>
                        <h2 className={styles.title}>
                            {t("about.title")}
                        </h2>
                        <p className={`${styles.about__text} global-p`}>
                            {t("about.content")}
                        </p>

                    </div>
                </div>
            </div>
        </Element>
    )
}

export default About;
